import * as React from 'react';
import * as SplashScreen from 'expo-splash-screen';
import * as Font from 'expo-font';
import {Ionicons} from '@expo/vector-icons';
import {ApplicationProvider, IconRegistry} from '@ui-kitten/components';
import * as eva from '@eva-design/eva';
import Amplify, {Auth, Hub} from 'aws-amplify';
import awsConfig from './aws-exports';
import {bindActions, Context, initialState, reducer} from './store'
import * as Sentry from 'sentry-expo';
import * as Notifications from 'expo-notifications';
import Main from './components/main'
import {EvaIconsPack} from '@ui-kitten/eva-icons';
import {Provider} from 'react-redux'
import {configureStore} from "./adapters/primary/redux/configureStore";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { SENTRY_DSN } from '@env'

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: false,
        shouldSetBadge: false,
    })
});

Sentry.init({
    dsn: 'https://c57902c5e7d94cf0bdfe3d16c68b6a0b@o903385.ingest.sentry.io/5843049',
    enableInExpoDevelopment: false,
    debug: true
});

Amplify.configure(awsConfig);
Auth.configure(awsConfig);

const reduxStore = configureStore()

SplashScreen.preventAutoHideAsync();

function App() {
    const [isLoadingComplete, setLoadingComplete] = React.useState(false);

    const [store, dispatch] = React.useReducer(reducer, initialState)
    const actions = bindActions(dispatch)

    React.useEffect(() => {
        (async () => {
            if (!!await AsyncStorage.getItem('@cguApproved')) actions.CGUApproved()
        })()
    }, [])


    React.useEffect(() => {
        Hub.listen('auth', ({ payload }) => {
            if(payload.event === 'signIn') {
                Auth.currentSession().then( (session) => {
                    actions.setAuthToken(session['idToken']['jwtToken'])
                })
            }
            if(payload.event === 'signOut') {
                actions.setAuthToken(false)
            }
        })

    }, [])

    // Load any resources or data that we need prior to rendering the app
    React.useEffect(() => {
        (async () => {
            try {
                // Load fonts
                await Font.loadAsync({
                    ...Ionicons.font,
                    'space-mono': require('./assets/fonts/SpaceMono-Regular.ttf'),
                });

                try {
                    const session = await Auth.currentSession()
                    console.log(session['idToken']['jwtToken'])
                    actions.setAuthToken(session['idToken']['jwtToken'])
                } catch {}

            } catch (e) {
                // We might want to provide this error information to an error reporting service
                console.warn(e);
            } finally {
                setLoadingComplete(true);
                await SplashScreen.hideAsync();
            }
        })()
    }, []);

    if (!isLoadingComplete) return null

    eva.light['color-primary-default'] = "#a0c946"
    eva.light['color-primary-active'] = "#a0c946"
    eva.light['border-primary-color-1'] = "#a0c946"
    eva.light['border-success-color-1'] = "#a0c946"

    return <Provider store={reduxStore}>
        <Context.Provider value={{ store, dispatch, actions }}>
            <IconRegistry icons={EvaIconsPack} />
            <ApplicationProvider {...eva} theme={eva.light}>
                <Main />
            </ApplicationProvider>
        </Context.Provider>
    </Provider>
}

export default App
